export const STATUS_LABELS = {
  received: 'دریافت شد',
  in_progress: 'در حال پیگیری',
  repaired: 'تعمیر شد',
  irreparable: 'غیرقابل تعمیر',
  warranty: 'شامل گارانتی',
  replaced: 'تعویض شد',
  not_visible: 'مشکل مشاهده نشد',
  sent: 'ارسال شد',
};

export const STATUS_COLORS = {
  received:     { bg: '#EFF6FF', text: '#1D4ED8', border: '#BFDBFE' },
  in_progress:  { bg: '#FFFBEB', text: '#B45309', border: '#FDE68A' },
  repaired:     { bg: '#F0FDF4', text: '#166534', border: '#BBF7D0' },
  irreparable:  { bg: '#FEF2F2', text: '#B91C1C', border: '#FECACA' },
  warranty:     { bg: '#F5F3FF', text: '#6D28D9', border: '#DDD6FE' },
  replaced:     { bg: '#ECFDF5', text: '#065F46', border: '#A7F3D0' },
  not_visible:  { bg: '#F1F5F9', text: '#475569', border: '#CBD5E1' },
  sent:         { bg: '#F0F9FF', text: '#0369A1', border: '#BAE6FD' },
};

export const STATUS_TRANSITIONS = {
  received:    ['in_progress'],
  in_progress: ['repaired', 'irreparable', 'warranty', 'replaced', 'not_visible'],
  repaired:    ['sent'],
  irreparable: ['sent'],
  warranty:    ['sent'],
  replaced:    ['sent'],
  not_visible: ['sent'],
  sent:        [],
};

export const PAYMENT_LABELS = { unpaid: 'پرداخت نشده', paid: 'پرداخت شده' };
